<template>
<div class="avatar">
  <div v-if="loading" class="avatar-loading"></div>
  <div v-else :style="{backgroundImage: avatarImage}">
    <span class="avatar-initials" v-if="!avatarImage">{{initials}}</span>
  </div>
</div>
</template>

<script>
import { mapGetters } from "vuex";
import * as CONSTANTS from "@/store/constants";

export default {
  props: {
    userid: String
  },
  computed: {
    ...mapGetters(["userImage", "userImageLoadState", "userName"]),
    avatarImage() {
      const userImage = this.userImage(this.userid)
      if (userImage === "none") return "";
      return 'url("data:image/png;base64,' + userImage + '")';
    },
    loading() {
      var loadState = this.userImageLoadState(this.userid);
      return loadState != CONSTANTS.LOAD_STATE_LOADED;
    },
    initials() {
        const fullName = this.userName(this.userid)
        return fullName ? fullName.split(" ").map(name => name.charAt(0)).join("") : ""
    },
  }
};
</script>

<style scoped>
.avatar {
  width: 32px !important;
  height: 32px !important;
  background-color: lightgray;
}
.avatar,
.avatar * {
  border-radius: 50%;
}
.avatar * {
  width: 100% !important;;
  height: 100% !important;;
  background-size: cover;
}
.avatar-loading {
  background-color: #1758A7;
  animation: sk-bounce 2s infinite ease-in-out;
}
.avatar-initials {
  color: white;
  font-size: 10px;
  font-weight: 700;
  line-height: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #2a9f93;
}
@-webkit-keyframes sk-bounce {
  0%,
  100% {
    -webkit-transform: scale(0);
  }
  50% {
    -webkit-transform: scale(1);
  }
}
@keyframes sk-bounce {
  0%,
  100% {
    transform: scale(0);
    -webkit-transform: scale(0);
  }
  50% {
    transform: scale(1);
    -webkit-transform: scale(1);
  }
}
</style>


// WEBPACK FOOTER //
// src/components/UserIcon.vue